// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"f93fb8fd85b4b9141d5e","691":"600a61f95a186e64ae7d"}[chunkId] + ".js";
};